import { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import Html from "./html";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

const Faq = () => {
  const searchState = { data: "" };
  const user = useSelector((state) => state.user);
  const [filters, setFilter] = useState({ page: 1, count: 10, search: "", status: "" });
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const history = useNavigate();

  useEffect(() => {
    setFilter({ ...filters, search: searchState.data });
    getData({ search: searchState.data });
  }, []);

  const getData = (p = {}) => {
    loader(true);
    let filter = { ...filters, ...p };
    ApiClient.get("faq/listing", filter).then((res) => { 
      if (res.success) {
        setData(res?.data);
        setTotal(res.total);
      }
      loader(false);
    });
  };

  const clear = () => {
    let f = { search: "", status: "" };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  };

  const filter = (p = {}) => {
    let f = { ...p };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  };

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  };

  const count = (e) => {
    setFilter({ ...filters, count: e });
    getData({ ...filters, count: e });
  };

  const edit = (id) => {
    history(`/faq/edit/${id}`); // Updated route for FAQ edit
  };

  const view = (id) => {
    let url = `/faq/detail/${id}`; // Updated route for FAQ detail
    history(url);
  };

  const isAllow = (key = "") => {
    if (user?.role?.name === "admin") return true;
    let permissions = user.Permission;
    let value = permissions?.[key];
    return value;
  };

  const handleSearch = (e) => {
    setFilter({ ...filters, search: e.target.value });
    if (e.target.value === "") {
      getData({ search: "" });
    }
  };
  const deleteFAQ = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete this FAQ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        loader(true);
        ApiClient.delete(`faq/delete?id=${id}`)
          .then((res) => {
            if (res.success) {
              Swal.fire("Deleted!", "Your FAQ has been deleted.", "success");
              getData({}); 
            } else {
              Swal.fire("Failed!", res.message || "Something went wrong.", "error");
            }
            loader(false);
          })
          .catch((error) => {
            Swal.fire("Error!", "An error occurred while deleting the FAQ.", "error");
            loader(false);
          });
      }
    });
  };  
  const changestatus = (e, key) => {
    setFilter({ ...filters, [key]: e });
    getData({ [key]: e });
  }
  const statusChange = (itm) => {
    // Toggle status based on the current status of the item
    let status = itm.status === "active" ? "deactive" : "active";
  
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status === "active" ? "Activate" : "Deactivate"} this FAQ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        loader(true); 
        ApiClient.put("faq/status/change", {  id: itm?._id || itm?.id, status })
          .then((res) => {
            if (res.success) {
              getData({}); 
               
            }
            loader(false);  
          })
          .catch((error) => {
            loader(false);  
            console.error("Error updating status:", error);
          });
      }
    });
  };
  
  return (
    <>
      <Html
        edit={edit}
        view={view}
        clear={clear}
        isAllow={isAllow}
        count={count}
        pageChange={pageChange}
        filters={filters}
        setFilter={setFilter}
        filter={filter}
        data={data}
        total={total}
        handleSearch={handleSearch}
        deleteFAQ={deleteFAQ}
        statusChange={statusChange}
        changestatus={changestatus}
      />
    </>
  );
};

export default Faq;
